import css from './index.module.scss';
import { ListPlaceholder, PaginationScroller, SearchBar, SelectLabel } from '@components/common';
import { IconNode, ToolTip } from '@components/base';
import Images from '@assets/images';
import { IQuoteListingState, PaginationNavigator } from '../..';
import QuoteDraftCard from '../draft-card';
import { MARKET_TYPE_OPTIONS } from '@helpers/constants';
import { useSearchParams } from 'react-router-dom';
import SkeletonQuoteListing from '../skeleton';

const EnquiryDraftListing = (props: any) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const {
    setQuoteState,
    quoteState,
    handleOrderSearch,
    itemLimit,
    validatePageChange,
    fetchEnquiryList
  } = props;

  const {
    isSearchLoading,
    currentPageNumber,
    draftCount,
    enquiryList,
    searchText,
    activeStep,
    isLoading,
    market_type
  } = quoteState;

  const handleMarketTypeChange = (value: any) => {
    setQuoteState((prevState: IQuoteListingState) => ({
      ...prevState,
      market_type: value
    }));
  };

  return (
    <div className={css.mainwrapper}>
      <section className={css.enquiryFilters}>
        <div className={css.filterSearchSelect}>
          <div className={css.searchBar}>
            <SearchBar
              isLoading={isSearchLoading}
              placeholder="Search"
              value={searchText}
              className={css.search}
              onChange={handleOrderSearch}
            />
            <div>
              <ToolTip title={'Search By: Draft Id'} placement="right">
                <div>
                  <IconNode src={Images.alertGrey} alt="eye icon" />
                </div>
              </ToolTip>
            </div>
          </div>
          <SelectLabel
            options={MARKET_TYPE_OPTIONS}
            placeholder="Market Type"
            value={market_type}
            isClearable
            onChange={handleMarketTypeChange}
            rootClassName={css.selectLabel}
            dropdownDirection={'bottom'}
          />
        </div>
        <PaginationNavigator
          currentPageNumber={currentPageNumber}
          count={draftCount}
          itemLimit={itemLimit}
          validatePageChange={validatePageChange}
        />
      </section>
      <section className={css.enquiryDraftGrid}>
        {isLoading ? (
          <SkeletonQuoteListing />
        ) : draftCount > 0 ? (
          enquiryList.map((enquiry: any, index: number) => (
            <div key={enquiry.enquiry_id} className={css.draftCardWrapper}>
              <QuoteDraftCard data={enquiry} fetchEnquiryList={fetchEnquiryList} />
            </div>
          ))
        ) : (
          !isLoading && (
            <div className={css.emptyStateWrapper}>
              <ListPlaceholder
                handleButtonClick={() => {
                  setSearchParams({
                    ...Object.fromEntries(searchParams),
                    showQuoteForm: 'true'
                  });
                }}
                title="No Draft Enquiry Added Yet"
                supportingText="When a Draft Enquiry is added by you, they will show up here"
                buttonText="Add Enquiry"
              />
            </div>
          )
        )}
      </section>
      {!isLoading && (
        <PaginationScroller
          variant="text"
          defaultPage={1}
          count={draftCount}
          pageLimit={itemLimit}
          page={currentPageNumber}
          onChange={validatePageChange}
        />
      )}
    </div>
  );
};

export default EnquiryDraftListing;
